import { TelegramAuthStatus } from "../enums/TelegramAuthStatus";

export const QR_POLLING_INTERVAL_SEC = 25;
export const QR_TIMER_UPDATE_INTERVAL_MS = 1000;

export const TERMINAL_STATUSES = [
    TelegramAuthStatus.Authorized,
    TelegramAuthStatus.Error,
    TelegramAuthStatus.EmptySettings,
    TelegramAuthStatus.StartChannel,
    TelegramAuthStatus.RequiresPassword,
    TelegramAuthStatus.RequiresManualInput
];